import type { QueryOptions } from "@tanstack/react-query";

/**
 * Retry request on abort error.
 */
export const retryOnAbort: QueryOptions["retry"] = (_, error: Error) => error?.name === "AbortError";
